export const RolesActionTypes = {
    FETCH_ROLES_START: 'FETCH_ROLES_START_NEW',
    FETCH_ROLES_SUCCESS: 'FETCH_ROLES_SUCCESS_NEW',
    FETCH_ROLES_FAILURE: 'FETCH_ROLES_FAILURE_NEW',
    SET_SEARCH_ROLES_QUERY: 'SET_SEARCH_ROLES_QUERY_NEW',
    ADD_SELECTED_ROLE: 'ADD_SELECTED_ROLE_NEW',
    DELETE_SELECTED_ROLE: 'DELETE_SELECTED_ROLE_NEW',
    SET_SELECTED_ROLE: 'SET_SELECTED_ROLE_NEW',
    SET_ROLES_ON_PAGE: 'SET_ROLES_ON_PAGE_NEW',
}